<template>
  <!--vue3.0和Ts的模板 -->
  <div class="head-box">
    <div class="header-main">
      <div class="header-main-img">
        <img src="../../assets/imgs/headerLogo.png" alt="加载中" />
      </div>
      <div class="header-main-btn">
        <el-button type="primary" @click="scrollBottom">立即购买</el-button>
        <el-button type="primary" plain @click="login">登录</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HomeHeader',
  setup(props, { emit }) {
    const loginUrl = process.env.VUE_APP_LOGIN
    // 滚动到底部
    const scrollBottom = () => {
      emit('intoView')
    }
    // 跳转到pc登录界面
    const login = () => {
      window.open(loginUrl, '_self')
    }
    return { scrollBottom, login, loginUrl }
  },
})
</script>
<style lang="scss" scoped>
@mixin home-head-style($height, $background) {
  height: $height;
  background: $background;
}
@mixin head-main($height, $width) {
  height: $height;
  width: $width;
}
.head-box {
  @include home-head-style(76px, #ffffff);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: -2px 4px 4px 0px rgba(188, 218, 251, 0.43);
}
.header-main {
  @include head-main(inherit, 80%);
  display: flex;
  align-items: center;
  div {
    height: inherit;
    display: flex;
    align-items: center;
  }
  &-btn {
    margin-left: auto;
  }
  &-img {
    img {
      display: block;
      height: 55px;
      width: 102px;
    }
  }
}
</style>
